import { Box, Text, useColorModeValue } from '@chakra-ui/react';
import type { BoxProps } from '@chakra-ui/react';

interface SectionCardProps extends BoxProps {
  title?: string;
  children: React.ReactNode;
}

const SectionCard = ({ title, children, ...rest }: SectionCardProps) => {
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

  return (
    <Box
      p={5}
      borderWidth="1px"
      borderColor={borderColor}
      borderRadius="lg"
      bg="white"
      shadow="md"
      _dark={{ bg: 'navy.800' }}
      {...rest}
    >
      {title && (
        <Text
          fontSize="xs"
          fontWeight="700"
          textTransform="uppercase"
          letterSpacing="wide"
          color="gray.500"
          mb={3}
        >
          {title}
        </Text>
      )}
      {children}
    </Box>
  );
};

export default SectionCard;
